// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"96":"invites-ui","175":"PrototypeViewer","182":"account-ui","230":"DevToolbar","233":"askhub-subscription-ui","348":"people-ui","551":"static-ui","698":"askhub-auth-ui","767":"askhub-dashboard"}[chunkId] || chunkId) + ".chunk.js";
};